import React, { useContext, useState, useEffect, useRef } from "react";
import { AuthContext } from "store/AuthProvider";
import { StoreContext } from "store/StoreProvider";
import { PickemLayoutPage } from "layouts/PickemLayoutPage";
import { Link } from "react-router-dom"
import { PickemTable } from "components/common/Table/PickemTable";
import { headList } from "./model";
//import { Breadcrumbs } from "components/common/Breadcrumbs";
//import { NoResults } from "components/common/NoResults";
import { Spinner } from "components/common/Spinner/Spinner";
import { withDialog } from "components/common/withDialog/withDialog";
import { TextInput } from "components/common/Form/TextInput/TextInput";
import Checkbox from "components/common/Form/Checkbox/Checkbox";
import { Select } from "components/common/Form/Select/Select";
//import { Select } from "components/common/Form/Select/Select";
//import Confirmation from "modals/Confirmation";
import { simpleOptions, options } from "utils/helpers";
import "./PickemGroupPicksPage.scss";

//const CryptoJS = require("crypto-js");

//GetPickset -> know competitor, competition, currentWeek, regular weeks + postseason weeks to build the page

//TODO: turn on post season for current week possibility

const PickemGroupPicksPage = ({
    history,
    location,
    match: {
        params: {
            competitionId
        }

    }
    }) => {
    const { functions, accountData, user } = useContext(AuthContext);
    const { updateMeta, competitionData, updateCompetitionData } = useContext(StoreContext);
    const [groupPickData, setGroupPickData] = useState({});
    const [groupPicksDisplayData, setGroupPicksDisplayData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingGroupPickData, setIsLoadingGroupPickData] = useState(true)
    const [currentWeek, setCurrentWeek] = useState(null);
    const [selectedWeek, setSelectedWeek] = useState(null)
    const [eventData, setEventData] = useState({});
    const [tiebreakData, setTiebreakData] = useState([]);
    const [tiebreakDisplayData, setTiebreakDisplayData] = useState([])
    const [nameString, setNameString] = useState(null)
    const [competitionName, setCompetitionName] = useState(null)
    const [competitionDescription, setCompetitionDescription] = useState(null)
    const [pointSort, setPointSort] = useState("desc")
    const [matchupSort, setMatchupSort] = useState(false)
    const [matchupSchedule, setMatchupScehedule] = useState([])
    const [competitionType, setCompetitionType] = useState(null)

    useEffect(() => {
        updateMeta({
            title: "Group Picks",
        });
    }, []);

    useEffect(() => {
        let name = ""
        if (accountData.firstName && accountData.lastName) {
            name = `${accountData.firstName} ${accountData.lastName}`
        }
        else if (accountData.firstName) {
            name = `${accountData.firstName}`
        }
        else if (accountData.lastName) {
            name = `${accountData.lastName}`
        }
        else if (user.email) {
            name = `${user.email}`
        }
        
        setNameString(name)
        if (competitionData.competitionDescription) {
            setCompetitionDescription(competitionData.competitionDescription)
        }
        if (competitionData.competitionName) {
            setCompetitionName(competitionData.competitionName)
        }
        
    }, [competitionData])

    useEffect(() => {
        getGroupData(currentWeek)
    }, [])

    useEffect(() => { 
        if (Object.keys(groupPickData).length > 0 && tiebreakData.length > 0) {
            analyzeGroupData()
        } 
    }, [groupPickData, tiebreakData])

    useEffect(() => {
        console.log("Analyze Data:", eventData)
        analyzeEventData()
    }, [eventData])

    useEffect(() => {
        setIsLoadingGroupPickData(false)
    }, [groupPicksDisplayData])

    const getGroupData = (weekNumber) => {
        functions.httpsCallable('pickemGroupPicksPage')({
            body: JSON.stringify({
                competitionId: competitionId,
                currentWeek: weekNumber
            })
        }).then((result) => {
            setIsLoading(false)
            console.log("Pickset Result:", result.data.success)
            if (result.data.success) {
                setIsLoading(false)
                setGroupPickData({...result.data.data.eventData})
                setTiebreakData([...result.data.data.tiebreakData])
                setMatchupScehedule([...result.data.data.matchupSchedule])
                setCompetitionType(result.data.data.competitionType)
                //setInitialEventData(() => ({...result.data.data.eventData}))
                if (!weekNumber) {
                    setCurrentWeek(result.data.data.currentWeek)
                }
            } else {
                if (result.data.message === "Competitor not in competition") {
                    history.push(`/pickem-join/${competitionId}`)
                }
            }
        })
    }

    const analyzeGroupData = () => {
        const eventRows = {
            "Favored": [],
            "Scores": [],
            "Spread": [],
            "Underdog": [],
            "Status": [],
            "EventIds": [],
            "Winners": []
        }
        if (groupPickData.competitorData) {
            const competitorKey = Object.keys(groupPickData.competitorData)[0]
            for (const event in groupPickData.competitorData[competitorKey].events) {
                const data = groupPickData.competitorData[competitorKey].events[event]
                eventRows["Favored"].push(data.favoriteShort)
                const scoreString = data.favoriteScore && data.underdogScore ? `${data.favoriteScore} - ${data.underdogScore}` : "-"
                eventRows["Scores"].push(scoreString)
                eventRows["Spread"].push(data.pointSpreadFavorite)
                eventRows["Underdog"].push(data.underdogShort)
                eventRows["Status"].push(data.status)
                eventRows["EventIds"].push(data.eventId)
                eventRows["Winners"].push(data.winner)
            }
    
            setEventData(eventRows)
        }
        const tiebreakRows = {
            "Favored": [],
            "Scores": [],
            "Spread": [],
            "Underdog": [],
            "Status": [],
            "EventIds": [],
            "Winners": []
        }
        if (tiebreakData.length > 0) {
            for (const event of tiebreakData) {
                tiebreakRows["Favored"].push(event.favoriteShort)
                const scoreString = event.favoriteScore && event.underdogScore ? `${event.favoriteScore} - ${event.underdogScore}` : "-"
                tiebreakRows["Scores"].push(scoreString)
                tiebreakRows["Spread"].push(event.pointSpreadFavorite)
                tiebreakRows["Underdog"].push(event.underdogShort)
                tiebreakRows["Status"].push(event.status)
                tiebreakRows["EventIds"].push(event.eventId)
                tiebreakRows["Winners"].push(event.winner)
            }

            setTiebreakDisplayData(tiebreakRows)
        }
        
    }

    const analyzeEventData = () => {
        let groupPicksByUser = []
        
        if (groupPickData.competitorData) {
            for (const competitorId in groupPickData.competitorData) {
                const competitor = groupPickData.competitorData[competitorId]
                const competitorPickData = []
                for (const id of eventData.EventIds) {
                    competitorPickData.push(
                        {
                            pick: competitor.events[id].userPickShort,
                            point: competitor.events[id].point,
                            status: competitor.events[id].status
                        })
                }

                const competitorObj = {
                    id: competitor.id,
                    isRandomUser: competitor.isRandomUser,
                    name: competitor.name,
                    picksetName: competitor.picksetName,
                    points: competitor.points,
                    tiebreakerTotal0: competitor.tiebreakerTotal0,
                    tiebreakerHome0: competitor.tiebreakerHome0,
                    tiebreakerAway0: competitor.tiebreakerAway0,
                    tiebreakerTotal1: competitor.tiebreakerTotal1,
                    tiebreakerHome1: competitor.tiebreakerHome1,
                    tiebreakerAway1: competitor.tiebreakerAway1,
                    joinedAt: competitor.joinedAt,
                    orderedPicks: competitorPickData
                }
                groupPicksByUser.push(competitorObj)
            }

            setGroupPicksDisplayData(() => groupPicksByUser.sort((a, b) => b.points - a.points || a.tiebreakerTotal0 - b.tiebreakerTotal0 || a.tiebreakerHome0 - b.tiebreakerHome0 || a.tiebreakerAway0 - b.tiebreakerAway0 || a.tiebreakerTotal1 - b.tiebreakerTotal1 || a.tiebreakerHome1 - b.tiebreakerHome1 || a.tiebreakerAway1 - b.tiebreakerAway1 || a.joinedAt - b.joinedAt))
        }
        
    }

    const weekClicked = (e) => {
        setIsLoadingGroupPickData(true)
        setSelectedWeek(e.target.value)
        getGroupData(e.target.value)
    }

    const createWeeks = (numWeeks, isPost) => {
        const weekList = []
        const selected = {}
        for (let weekNumber = 1; weekNumber <= numWeeks; weekNumber++) {
            const weekId = isPost ? weekNumber + groupPickData.regWeeks : weekNumber
            const isCurrentWeek = currentWeek === weekId
            selected[weekId] = isCurrentWeek
            //weekList.push((<div key={weekNumber} onClick={weekClicked} className={`col PickemGroupPicksPage-weeks ${isCurrentWeek ? "PickemGroupPicksPage-selected": null}`}><p>{weekNumber}</p></div>))
            weekList.push((<button key={weekId} value={weekId} onClick={e => weekClicked(e, "value")} className={`PickemGroupPicksPage-weekButton ${isCurrentWeek ? "PickemGroupPicksPage-currentWeek": "PickemGroupPicksPage-notCurrentWeek"}  ${Number(selectedWeek) === weekId ? "PickemGroupPicksPage-selectedWeek": null}`}>{weekNumber}</button>))
        }
        return weekList
    }

    const createCompetitorData = () => {
        console.log("Create Competitor:", groupPicksDisplayData.length)
        if (groupPicksDisplayData.length > 0 && eventData["Favored"]) {
            return (
                <div className="PickemGroupPicksPage-scrollableDiv">
                <table className="PickemGroupPicksPage-table">
                    <tbody>
                        <tr>
                            <td className="PickemGroupPicksPage-td-label">Favored</td>
                            <td className="PickemGroupPicksPage-td">&nbsp;</td>
                            {eventData["Favored"].map((f, i) => (<td className={`${eventData["Winners"][i] ? (eventData["Winners"][i] === f ? "PickemGroupPicksPage-td-win" : "PickemGroupPicksPage-td-lose") : "PickemGroupPicksPage-td"}`}>{f}</td>))}
                            <td className="PickemGroupPicksPage-td-space">&nbsp;</td>
                            {tiebreakDisplayData["Favored"].map((f, i) => (<td className={`${tiebreakDisplayData["Winners"][i] ? (tiebreakDisplayData["Winners"][i] === f ? "PickemGroupPicksPage-td-win" : "PickemGroupPicksPage-td-lose") : "PickemGroupPicksPage-td"}`}>{f}</td>))}
                        </tr>
                        <tr>
                            <td className="PickemGroupPicksPage-td-label">{competitionType === "Baseball" || competitionType === "Hockey" ? "Odds" : "Spread"}</td>
                            <td className="PickemGroupPicksPage-td">&nbsp;</td>
                            {eventData["Spread"].map((f) => (<td className="PickemGroupPicksPage-td">{f}</td>))}
                            <td className="PickemGroupPicksPage-td-space">&nbsp;</td>
                            {tiebreakDisplayData["Spread"].map((f) => (<td className="PickemGroupPicksPage-td">{f}</td>))}
                        </tr>
                        <tr>
                            <td className="PickemGroupPicksPage-td-label">Underdog</td>
                            <td className="PickemGroupPicksPage-td">&nbsp;</td>
                            {eventData["Underdog"].map((f, i) => (<td className={`${eventData["Winners"][i] ? (eventData["Winners"][i] === f ? "PickemGroupPicksPage-td-win" : "PickemGroupPicksPage-td-lose") : "PickemGroupPicksPage-td"}`}>{f}</td>))}
                            <td className="PickemGroupPicksPage-td-space">&nbsp;</td>
                            {tiebreakDisplayData["Underdog"].map((f, i) => (<td className={`${tiebreakDisplayData["Winners"][i] ? (tiebreakDisplayData["Winners"][i] === f ? "PickemGroupPicksPage-td-win" : "PickemGroupPicksPage-td-lose") : "PickemGroupPicksPage-td"}`}>{f}</td>))}
                        </tr>
                        <tr> 
                            <td className="PickemGroupPicksPage-td-label">Score</td>
                            <td className="PickemGroupPicksPage-td">&nbsp;</td>
                            {eventData["Scores"].map((f) => (<td className="PickemGroupPicksPage-td">{f}</td>))}
                            <td className="PickemGroupPicksPage-td-space">&nbsp;</td>
                            {tiebreakDisplayData["Scores"].map((f) => (<td className="PickemGroupPicksPage-td">{f}</td>))}
                        </tr>
                        <tr>
                            <td className="PickemGroupPicksPage-td-label">Status</td>
                            <td className="PickemGroupPicksPage-td">&nbsp;</td>
                            {eventData["Status"].map((f) => (<td className="PickemGroupPicksPage-td">{"-"}</td>))}
                            <td className="PickemGroupPicksPage-td-space">&nbsp;</td>
                            {tiebreakDisplayData["Status"].map((f) => (<td className="PickemGroupPicksPage-td">{"-"}</td>))}
                        </tr>
                        <tr></tr>
                    {groupPicksDisplayData.map((competitor, i) => {
                        return (
                            <tr>
                                <td className="PickemGroupPicksPage-td-label">
                                    <Link to={{pathname: `/pickem-picks/${competitionId}`}} onClick={() => updateCompetitionData({name: competitor.name, picksUserId: competitor.id, isRandomUser: competitor.isRandomUser, shownPicksetName: competitor.picksetName})}>
                                        {competitor.picksetName}
                                    </Link>
                                </td>
                                <td className="PickemGroupPicksPage-td">{competitor.points}</td>
                                {competitor.orderedPicks.map((item) => {
                                    return (<td className={`${determineStatusStyle(item)}`}>{item.pick ? item.pick : "-"}</td>)
                                })}
                                <td className="PickemGroupPicksPage-td-space">&nbsp;</td>
                                <td className="PickemGroupPicksPage-td">{competitor.tiebreakerTotal0}</td>
                                <td className="PickemGroupPicksPage-td">{competitor.tiebreakerHome0}</td>
                                <td className="PickemGroupPicksPage-td">{competitor.tiebreakerAway0}</td>
                                <td className="PickemGroupPicksPage-td">{competitor.tiebreakerTotal1}</td>
                                <td className="PickemGroupPicksPage-td">{competitor.tiebreakerHome1}</td>
                                <td className="PickemGroupPicksPage-td">{competitor.tiebreakerAway1}</td>
                                <td className="PickemGroupPicksPage-td-space">&nbsp;</td>
                                <td className="PickemGroupPicksPage-td">{competitor.points}</td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
                </div>
            )
        }
    }

    const  createHeaderData= () => {
        if (eventData["Favored"]) {
            return (
                <div className="PickemGroupPicksPage-scrollableDiv">
                <table className="PickemGroupPicksPage-table">
                    <tbody>
                        
                    </tbody>
                    
                </table>
                </div>
            )
        }
    }

    const determineStatusStyle = (item) => {
        let className = "PickemGroupPicksPage-td"
        if (item.status === "final" || item.status === "f/ot") {
            if (item.point) {
                className = "PickemGroupPicksPage-td-win"
            }
            else if (item.push) {
                className = "PickemGroupPicksPage-td"
            }
            else if (item.point === 0) {
                className = "PickemGroupPicksPage-td-lose"
            }
            else {
                className = "PickemGroupPicksPage-td"
            }
        }

        return className
    }

    const MatchupSortButton = () => {
        return (
            <button style={{ fontSize: "1em", margin: "0.5em", width: "5em" }}
            className={`btn-primary ${matchupSort ? "PickemGroupPicksPage-matchupSelected" : null}`} onClick={sortByMatchup}
        >
            Matchups
        </button>
        )
    }

    const PointSortButton = () => {
        return (
            <button style={{ fontSize: "1em", margin: "0.5em", width: "5em" }}
            className={`btn-primary`} onClick={sortByPoints}
        >
            Points {pointSort === "desc" ? <img src="/images/downArrow.png" style={{marginLeft: "0.25em", height:".75em", width:"0.75em"}} alt="Dsc" /> : <img src="/images/upArrow.png" style={{marginLeft: "0.25em", height:".75em", width:"0.75em"}} alt="Asc" />}
        </button>
        )
    }

    const sortByPoints = () => {
        if (pointSort === "desc") {
            setPointSort("asc")
            setGroupPicksDisplayData(() => groupPicksDisplayData.sort((a, b) => a.points - b.points || b.tiebreakerTotal0 - a.tiebreakerTotal0 || b.tiebreakerHome0 - a.tiebreakerHome0 || b.tiebreakerAway0 - a.tiebreakerAway0 || b.tiebreakerTotal1 - a.tiebreakerTotal1 || b.tiebreakerHome1 - a.tiebreakerHome1 || b.tiebreakerAway1 - a.tiebreakerAway1 || b.joinedAt - a.joinedAt))
            console.log("asc")
        }
        else {
            setPointSort("desc")
            setGroupPicksDisplayData(() => groupPicksDisplayData.sort((a, b) => b.points - a.points || a.tiebreakerTotal0 - b.tiebreakerTotal0 || a.tiebreakerHome0 - b.tiebreakerHome0 || a.tiebreakerAway0 - b.tiebreakerAway0 || a.tiebreakerTotal1 - b.tiebreakerTotal1 || a.tiebreakerHome1 - b.tiebreakerHome1 || a.tiebreakerAway1 - b.tiebreakerAway1 || a.joinedAt - b.joinedAt))
            console.log("desc")
        }
    }

    const sortByMatchup = () => {
        if (!matchupSort) {
            const matchupRank = {}
            const matchupSortGroupPicks = []
            for (const data of groupPicksDisplayData) {
                console.log("Matchup Rank:", matchupRank[data.id], data.id)
                if (!matchupRank[data.id]) {
                    let matchup = matchupSchedule.filter((match) => match.homeCompetitor === data.id || match.awayCompetitor === data.id)
                    matchup = matchup[0]
                    console.log("Matchup:", matchup)
                    const homeMatch = matchup.homeCompetitor === data.id ? true : false
                    if (homeMatch) {
                        matchupSortGroupPicks.push(data)
                        let matchupOpponent = groupPicksDisplayData.filter((picks) => picks.id === matchup.awayCompetitor)
                        matchupOpponent = matchupOpponent[0]
                        matchupSortGroupPicks.push(matchupOpponent)
                        matchupRank[data.id] = 1
                        matchupRank[matchupOpponent.id] = 2
                    } else {
                        matchupSortGroupPicks.push(data)
                        let matchupOpponent = groupPicksDisplayData.filter((picks) => picks.id === matchup.homeCompetitor)
                        matchupOpponent = matchupOpponent[0]
                        matchupSortGroupPicks.push(matchupOpponent)
                        matchupRank[data.id] = 1
                        matchupRank[matchupOpponent.id] = 2
                    }
                }
            }

            setGroupPicksDisplayData(() => matchupSortGroupPicks)

        } else {
            if (pointSort === "desc") {
                setGroupPicksDisplayData(() => groupPicksDisplayData.sort((a, b) => b.points - a.points || a.tiebreakerTotal0 - b.tiebreakerTotal0 || a.tiebreakerHome0 - b.tiebreakerHome0 || a.tiebreakerAway0 - b.tiebreakerAway0 || a.tiebreakerTotal1 - b.tiebreakerTotal1 || a.tiebreakerHome1 - b.tiebreakerHome1 || a.tiebreakerAway1 - b.tiebreakerAway1 || a.joinedAt - b.joinedAt))
            }
            else {
                setGroupPicksDisplayData(() => groupPicksDisplayData.sort((a, b) => a.points - b.points || b.tiebreakerTotal0 - a.tiebreakerTotal0 || b.tiebreakerHome0 - a.tiebreakerHome0 || b.tiebreakerAway0 - a.tiebreakerAway0 || b.tiebreakerTotal1 - a.tiebreakerTotal1 || b.tiebreakerHome1 - a.tiebreakerHome1 || b.tiebreakerAway1 - a.tiebreakerAway1 || b.joinedAt - a.joinedAt))
                
            }
        }
        setMatchupSort(!matchupSort)
    }

    return (
        <PickemLayoutPage
            title={`${competitionName} Group Picks`}
            name={nameString} 
            competitionName={competitionName} 
            competitionDescription={competitionDescription}
        >
            <div className="PickemGroupPicksPage">
                <div className="PickemGroupPicksPage-weekView">
                    {!isLoading && groupPickData.regWeeks ? <div className="PickemGroupPicksPage-weeks">
                        <div className="PickemGroupPicksPage-weeks">
                            <div style={{margin: '0.25em'}}><p>Regular</p></div>
                            {
                                createWeeks(groupPickData.regWeeks, false)
                            }
                        </div>
                    </div> : null}
                    {!isLoading && groupPickData.postWeeks ? <div className="PickemGroupPicksPage-weeks">
                        <div className="PickemGroupPicksPage-weeks">
                            <div style={{margin: '0.25em'}}><p>Post</p></div>
                            {
                                createWeeks(groupPickData.postWeeks, true)
                            }
                        </div>
                    </div> : null}
                </div>
                
                {!isLoadingGroupPickData && groupPicksDisplayData.length > 0 ? <div>
                    <div  style={{ display: "flex", flexDirection: "row", fontSize: "1em"}}>
                        <MatchupSortButton/>
                        <PointSortButton/>
                    </div>    
                </div> :  null}
                <div>
                    {!isLoadingGroupPickData && groupPicksDisplayData.length > 0 ? createCompetitorData() : <Spinner /> }
                </div>
            </div>
            
            
        </PickemLayoutPage>
    );
};

export default withDialog(PickemGroupPicksPage);
